<form [formGroup]="form">
  <div formArrayName="inputUrlOrTextList" class="flex flex-col gap-2">
    @for (
      item of inputUrlOrTextArray.controls;
      track $index;
      let idx = $index
    ) {
      <p-inputgroup>
        <p-floatlabel variant="on">
          <textarea
            [id]="'text-or-url-' + idx"
            pTextarea
            [fluid]="true"
            rows="2"
            autoResize="true"
            [formControl]="item"
            [readonly]="readonly ? 'readonly' : null"
            style="max-height: 96px"></textarea>
          <label [for]="'text-or-url-' + idx">Enter text or link to text</label>
        </p-floatlabel>
        @if (inputUrlOrTextArray.controls.length > 1 || item.value) {
          <p-inputgroup-addon>
            <p-button
              icon="pi pi-trash"
              severity="secondary"
              variant="text"
              [disabled]="readonly"
              (click)="removeSource(idx)" />
          </p-inputgroup-addon>
        }
        @if (
          idx === inputUrlOrTextArray.controls.length - 1 &&
          inputUrlOrTextArray.controls.length < maxSourceItems
        ) {
          <p-inputgroup-addon>
            <p-button
              icon="pi pi-plus"
              severity="secondary"
              variant="text"
              [disabled]="readonly"
              (click)="addSource()" />
          </p-inputgroup-addon>
        }
      </p-inputgroup>
    }
  </div>
</form>
